import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Windows_grey",
  "use": "Windows_grey-usage",
  "viewBox": "0 0 40 40",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 40 40\" id=\"Windows_grey\"><defs><style>#Windows_grey .cls-1{fill:#999;}</style></defs><g id=\"Windows_grey_页面-1\"><g id=\"Windows_grey_环境配置-客户端下载--Linux\"><g id=\"Windows_grey_编组-2\"><g id=\"Windows_grey_RSA客户端备份\"><path id=\"Windows_grey_形状\" class=\"cls-1\" d=\"M17.5,36.72V20.83H40V40Zm0-33.44L40,0V19.17H17.5ZM15.84,19.17H0V5.83L15.84,3.52Zm0,17.31L0,34.17V20.83H15.84Z\" transform=\"translate(0 0)\" /></g></g></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol